import "./Header.scss";
import NavBar from "../../Navigation/NavBar/NavBar";

function Header() {
  return (
    <section className="header">
      <NavBar />
    </section>
  );
}

export default Header;
